import angular from 'angular';
import _ from "lodash";

import '../../../../services/cart';
import '../../../../filters/sum';

angular.module('folkeuni').component('cartProductConfirm', {
  templateUrl: '/shop-dist/templates/cart-product-confirm.html',
  bindings:{
    product:'<',
    onUpdate: '&',
    state: '<'
  },
  controller: function (Cart, $location) {
      var $ctrl = this;

      $ctrl.ticketTypes = [];
      $ctrl.standardAmount = 0;

      function getTicketTypes() {
        if(!$ctrl.product) {
          return [];
        }

        var types = $ctrl.product.quantity > $ctrl.product.discount.length ? [{type: 'Standard', name: 'Standard'}] : [];

        var discountTypes = _.chain($ctrl.product.discount)
        .map(function(discount) {
          return {
            type: discount.type,
            name: discount.name ? discount.name : discount.type
          };
        })
        .uniqBy('type')
        .value();

        types = types.concat(discountTypes);

        return types;
      };

      $ctrl.$onInit = function() {

          $ctrl.ticketTypes = getTicketTypes();
          $ctrl.standardAmount = $ctrl.product.quantity - $ctrl.product.discount.length;
          $ctrl.standardAmountPrevious = $ctrl.standardAmount;

      };
  }
});
